/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { updateAccountWithResult } from "@eisinc/App/Services/AccountService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    CallUpdateAccount,
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SaveUser";
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";

export const XngPopulateApiParameter: any = (props: any) => {
    // xng-change - make this assignable
    let editingUser = getCurrentEditingUser(props.getState());
    if (!editingUser) {
        return false;
    }

    props.accountSettings = getSettingsCollection(props.getState()).accountSettings;
    if (props.accountSettings.useEmailAsUserName) {
        // xng-change - to avoid readonly object type error
        editingUser = { ...editingUser, userName: editingUser.email };
    }

    props.apiParameter = {
        account: editingUser,
    };
};

// changing this to use modified service with 403 error status check
export const XngCallUpdateAccount: any = async (props: any) => {
    props.apiResult = await updateAccountWithResult(props.apiParameter);
};

replaceInChain(chain, CallUpdateAccount, XngCallUpdateAccount);
replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
